export const accountChurnLocationBased = {
  one: () => ['accountChurnLocationBased'] as const
}
